import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./dashboard.css";

const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 100%;
`;

const Title = styled.h2`
  color: #002e19;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin: 0;
`;

const CloseButton = styled.button`
  align-items: center;
  background: transparent;
  border: 2px solid #00140b;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  height: 48px;
  justify-content: center;
  padding: 0;
  width: 48px;
`;

const BodyText = styled.p`
  color: #002e19;
  font-size: 18px;
  letter-spacing: 0.25px;
  line-height: 26px;
  margin: 0;
`;

const Footer = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  margin-top: 24px;
`;

const ActionButton = styled.button`
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 700;
  height: 48px;
  justify-content: center;
  letter-spacing: 0.25px;
  line-height: 26px;
  padding: 0 16px;
  width: 180px;
  &:disabled {
    cursor: not-allowed;
  }
`;

const SecondaryButton = styled(ActionButton)`
  background: white;
  border: 1px solid #605dec;
  color: #605dec;
`;

const PrimaryButton = styled(ActionButton)`
  background: #605dec;
  border: none;
  color: #faf7f2;
  &:disabled {
    background: #d5d3ce;
  }
`;

const LESSON_BODY = (
  <>
    You are about to clear all active group codes for this lesson. This can&apos;t be undone, but your session
    reports are safe and will stay on your dashboard.
  </>
);

// Confirmation before archiving (clearing) a lesson's group codes. Figma 3463:15387.
// The copy props let other archives reuse it; their defaults are the lesson's.
export const ArchiveLessonModal = ({
  isOpen,
  onClose,
  onConfirm,
  archiving,
  title = "Ready to archive?",
  body = LESSON_BODY,
  keepLabel = "Keep Lesson",
  confirmLabel = "Yes, Archive",
  titleId = "archive-lesson-title",
}) => (
  <Modal show={isOpen} onHide={onClose} centered contentClassName="agdm-modal-content" aria-labelledby={titleId}>
    <Header>
      <Title id={titleId}>{title}</Title>
      <CloseButton aria-label="Close" onClick={onClose}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6 6 18M6 6l12 12" stroke="#00140B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </CloseButton>
    </Header>

    <BodyText>{body}</BodyText>

    <Footer>
      <SecondaryButton onClick={onClose} disabled={archiving}>{keepLabel}</SecondaryButton>
      <PrimaryButton onClick={onConfirm} disabled={archiving} aria-busy={archiving} aria-label={archiving ? "Archiving" : undefined}>
        {archiving ? <FontAwesomeIcon icon={faSpinner} spin /> : confirmLabel}
      </PrimaryButton>
    </Footer>
  </Modal>
);
